module.exports = __webpack_public_path__ + "0af5d249/img/pwrd-by-sourcery-black.bba9ba41.svg";